import styled from 'styled-components';

const Label = styled.label`
  display: block;
  font-size: 12px;
  margin: 0 0 5px 3px;
  font-weight: bold;
`;

export default Label;
